import React, { FC, Fragment, useState } from 'react';

import { post } from 'api/requests';
import { getISO8601DateRangeValue } from 'helpers';
import { SendExcel } from 'components/SendExcel';
import { IParamsReq } from 'types';
import { FilterKeys } from 'pages/Analytics/AnalyticsApartmentStatus/const';
import queryString from 'query-string';
import { useLocation } from 'react-router';
import { isBoolean } from 'lodash';

export const Extra: FC = () => {
  const [loading, setLoading] = useState(false);

  const { search } = useLocation();

  const handleSend = async ({ email }: IParamsReq) => {
    const parsedResult = queryString.parse(search, {
      parseBooleans: true,
      parseNumbers: true,
    });

    const copiedSearch = { ...parsedResult, email };

    for (const key in parsedResult) {
      if (
        isBoolean(parsedResult[key]) ||
        [FilterKeys.Start, FilterKeys.End].includes(key as FilterKeys) ||
        Array.isArray(parsedResult[key])
      ) {
        continue;
      }

      copiedSearch[key] = [parsedResult[key]];
    }

    const params = getISO8601DateRangeValue(copiedSearch);

    setLoading(true);

    post('/api/v2/analytics/apartments-chessboard/excel-report/', params).finally(() =>
      setLoading(false),
    );
  };

  return (
    <Fragment key='1'>
      <SendExcel text='Скачать Excel' onSend={handleSend} loading={loading} />
    </Fragment>
  );
};
